var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 19,
    viewBox: "0 0 15 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4469 5.1395L9.91875 0.551C9.57187 0.1995 9.09375 0 8.59688 0H1.875C0.84375 0 0 0.855 0 1.9V17.1C0 18.145 0.84375 19 1.875 19H13.125C14.1562 19 15 18.145 15 17.1V6.4885C15 5.985 14.8031 5.5005 14.4469 5.1395ZM9.375 9.5C9.89062 9.5 10.3125 9.9275 10.3125 10.45V13.3C10.3125 13.8225 9.89062 14.25 9.375 14.25H8.4375C8.4375 14.7725 8.01562 15.2 7.5 15.2C6.98438 15.2 6.5625 14.7725 6.5625 14.25H5.625C5.10938 14.25 4.6875 13.8225 4.6875 13.3C4.6875 12.7775 5.10938 12.35 5.625 12.35H8.4375V11.4H5.625C5.10938 11.4 4.6875 10.9725 4.6875 10.45V7.6C4.6875 7.0775 5.10938 6.65 5.625 6.65H6.5625C6.5625 6.1275 6.98438 5.7 7.5 5.7C8.01562 5.7 8.4375 6.1275 8.4375 6.65H9.375C9.89062 6.65 10.3125 7.0775 10.3125 7.6C10.3125 8.1225 9.89062 8.55 9.375 8.55H6.5625V9.5H9.375Z",
    fill: "#78909C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEdit);
export default __webpack_public_path__ + "static/media/ic_edit.42acb690.svg";
export { ForwardRef as ReactComponent };